import CreateQuery from "./CreateQuery";

export default CreateQuery;